import { FC } from "react";
import { Button, ButtonProps } from "@chakra-ui/react";

import { FONT_WEIGHT } from "@assets/theme/foundations/textStyle";

const CaseDocumentActionLink: FC<ButtonProps> = (props) => (
  <Button
    variant="link"
    fontSize="13px"
    fontWeight={FONT_WEIGHT.HEAVY}
    _disabled={{ opacity: 0.4, cursor: "not-allowed", textDecoration: "none" }}
    {...props}
  />
);

export default CaseDocumentActionLink;
